query GetMeetingForReportValue($id: ID!) {
    meeting(id: $id) {
        id
        name
        primaryHost {
            id
            name
        }
        cohosts {
            id
            name
        }
        bookingsCountLast90Days
    }
}
